"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var temp = function QuestionCircleTwotTwoTone(primaryColor, secondaryColor) {
    return {
        name: 'question-circle-twot',
        theme: 'twotone',
        nameWithTheme: 'question-circle-twot-twotone',
        tag: 'svg',
        attrs: {
            xmlns: 'http://www.w3.org/2000/svg',
            class: 'icon',
            viewBox: '0 0 1024 1024'
        },
        children: [
            {
                tag: 'path',
                attrs: {
                    fill: primaryColor,
                    d: 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
                },
                children: []
            },
            {
                tag: 'path',
                attrs: {
                    fill: secondaryColor,
                    d: 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm0 632c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm62.9-219.5c-18.5 7.1-30.9 25.1-30.9 44.8V620c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-21.5c0-23.1 6.7-45.9 19.9-64.9 12.9-18.6 30.9-32.8 52.1-40.9 34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V420c0-39.3 17.2-76 48.4-103.3C430.4 290.4 470 276 512 276s81.6 14.5 111.6 40.7C654.8 344 672 380.7 672 420c0 57.8-38.1 109.8-97.1 132.5z'
                },
                children: []
            },
            {
                tag: 'path',
                attrs: {
                    fill: primaryColor,
                    d: 'M472 732a40 40 0 1 0 80 0 40 40 0 1 0-80 0zM623.6 316.7C593.6 290.5 554 276 512 276s-81.6 14.4-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.2 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7c0-19.7 12.4-37.7 30.9-44.8 59-22.7 97.1-74.7 97.1-132.5 0-39.3-17.2-76-48.4-103.3z'
                },
                children: []
            }
        ]
    };
};
temp.nameWithTheme = 'question-circle-twot-twotone';
var QuestionCircleTwotTwoTone = temp;
exports.default = QuestionCircleTwotTwoTone;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/icons/lib/twotone/QuestionCircleTwotTwoTone.js
// module id = 1868
// module chunks = 0